









































import { Component, Vue, Emit } from 'vue-property-decorator'
import { getMajorLists } from '@/apis/courseList/courseList'
import i18n from '@/lang';
@Component({})
export default class MajorAdd extends Vue {
  private tabsList = [i18n.t('ktpMy.高等教育') as string, i18n.t('ktpMy.高职教育') as string, i18n.t('ktpMy.中职教育') as string]
  items: any = []
  private majorDetail: any = [] //rlist
  activeId: number = 1
  activeIndex: number = 0
  active: number = 0 //tabs
  activeList : number = 3
  listIndex: number = 0 //
  private chooseActive: number = -1 //rlists
  private majorName: string = '' //输入框专业名称
  private warnInfo: string = '' //警告信息
  private warnOn: boolean = false

  private tabName: string = ''
  private lName: string = ''
  private rName: string = ''

  //确定按钮
  hanFix() {
    if (this.majorName.length < 2 && this.majorName.length > 0) {
      this.warnInfo = i18n.t('ktpMy.请输入正确的专业') as string
      this.warnOn = true
    } else if (this.majorName.length == 0) {
      this.warnInfo = i18n.t('ktpMy.专业不能为空') as string
      this.warnOn = true
    } else {
      //进行保存操作
      this.chooseOnAdd(this.majorName, { type: '0', id: '', title: this.majorName })
      this.warnOn = false
      // this.chooseOn()
    }
  }
  deparentCalssd() {
    // this.majorName = this.majorName.replace(/[^\u4E00-\u9FA5\,，.]/g, '')
    if (this.majorName.length > 12) {
      this.majorName = this.majorName.slice(0, 12)
    }
  }
  //导航栏点击
  changeTabs() {
    if (this.active == 0) {
      this.activeList = 3
    }else{
      this.activeList = this.active
    }
    this.getMajorList(this.activeList, '0')
    this.tabName = this.tabsList[this.active]
  }
  //左侧点击
  navShow(index: number) {
    this.listIndex = index
    this.getMajorDetail(this.activeList, this.items[index].id)
    this.lName = this.items[index].title
  }
  //右侧点击
  @Emit('chooseOnAdd')
  chooseOnAdd(message: string, obj: any) {
    const msg = {
      mess: message,
      content: obj,
    }
    return msg
  }
  chooseOn(index: number) {
    this.chooseActive = index
    this.rName = this.majorDetail[index].title
    this.chooseOnAdd(this.tabName + '/' + this.lName + '/' + this.rName, { type: this.activeList, id: this.majorDetail[index].id, title: this.rName })
  }

  // 获取右侧数据
  getMajorDetail(typeNum: number, parentId: string) {
    getMajorLists({ type: typeNum, pid: parentId })
      .then((res: any) => {
        this.majorDetail = res

        if (res.length != 0) {
          this.rName = res[0].title
        }
      })
      .catch((e) => {})
  }
  //获取左侧数据
  getMajorList(typeNum: number, parentId: string) {
    getMajorLists({ type: typeNum, pid: parentId })
      .then((res: any) => {
        if (res.length != 0) {
          for (let i = 0; i < res.length; i++) {
            res[i].text = res[i].title
          }
          this.items = res
          this.lName = res[0].title
        }

        getMajorLists({ type: this.activeList, pid: res[this.listIndex].id }).then((res: any) => {
          this.majorDetail = res
          if (res.length != 0) {
            this.rName = res[0].title
          }
        })
      })
      .catch((e) => {})
  }

  created() {
    this.$setNavInfo({
      type: 'normal',
      title: i18n.t('ktpMy.新增专业') as string,
      showTitle: true,
    })
    this.getMajorList(3, '0')
  }
}
